<template>
  <div class="container-fluid mt-4" >

    <!-- 1. الفلاتر -->
    <ControlFilters 
      title="طباعة الشيت الرئيسي (جميع المواد)"
      icon="fas fa-print ms-2"
      :visible-filters="['admin','term','school','StudentType', 'DamgStatus', 'Moslem' , 'Nationality']"
      :loading="loading"
      @search="fetchReport"
      @print="printPage"
    />

    <!-- 2. منطقة الطباعة -->
<div id="printMe" v-if="schoolsData.length > 0">
      
      <!-- حلقة تكرار لكل مدرسة -->
      <div v-for="(school, index) in schoolsData" :key="index" class="school-section" style="page-break-after: always;">
        
        <!-- التأكد من وجود طلاب -->
        <div v-if="school.students && school.students.length > 0">
            
            <div class="sheet-page mb-5" dir="rtl">
            
                <div class="table-responsive">
                    <table class="table table-bordered border-dark align-middle text-center grades-table mb-0">
                    
                    <!-- ================================================= -->
                    <!-- الرأس: تم نقل الترويسة هنا لتتكرر في كل صفحة -->
                    <!-- ================================================= -->
                    <thead>
                        
                        <!-- الصف الأول: الترويسة الرسمية (بدون حدود) -->
                        <tr class="no-border-row">
                            <td colspan="7" class="p-0 border-0">
                                
                                <div class="header-section mb-2 pt-2">
                                    <div class="row align-items-center text-center g-3">
                                    
                                        <!-- اليمين -->
                                        <div class="col-3 text-start">
                                            <div class="header-text fs-6 fs-md-5">
                                                <p class="mb-0 fw-bold">محافظة شمال سيناء</p>
                                                <p class="mb-0 fw-bold">مديرية التربية والتعليم</p>
                                                <p class="mb-0 fw-bold">لجنة النظام والمراقبة</p>
                                            </div>
                                        </div>

                                        <!-- الوسط -->
                                        <div class="col-6">
                                            <h3 class="fw-bold text-decoration-underline mb-2 fs-4 fs-md-3">كشــــف رصد درجات</h3>
                                            <div class="fw-bold border border-dark p-2 d-inline-block bg-light rounded text-wrap">
                                                نشاط (1) - نشاط (2) - التربية الرياضية
                                            </div>
                                        </div>

                                        <!-- اليسار -->
                                        <div class="col-3 text-center">
                                            <div class="header-text fs-6 fs-md-5">
                                                <p class="mb-0 fw-bold"> {{ termName }}</p>
                                                <h4 class="mb-0 fw-bold mt-1">2026</h4>
                                                <p class="mb-0 fw-bold">
                                                    إدارة {{ school.admin_name || getAdminName(printOptions.admin) }} 
                                                </p>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- بيانات المدرسة -->
                                    <div class="school-info mt-2 border-top border-bottom border-2 border-dark py-2">
                                        <div class="row g-2">
                                            <div class="col-12 text-start">
                                                <span class="fw-bold fs-5">اسم المدرسة:</span>
                                                <span class="fw-bold fs-5 ms-2">{{ school.school_name }}</span>
                                                
                                                <span class="float-end fw-bold fs-5">
                                                    كود: <span class="border border-dark px-2 ms-2 bg-white small">{{ school.school_id || school.id }}</span>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </td>
                        </tr>

                        <!-- الصف الثاني: عناوين الأعمدة -->
                        <tr class="bg-light">
                            <th rowspan="2" style="min-width: 80px;">جلوس</th>
                            <th rowspan="2" style="min-width: 200px;">اسم الطالب</th>
                            <th colspan="2">نشاط (1)</th>
                            <th colspan="2">نشاط (2)</th>
                            <th rowspan="2">تربية رياضية (20)</th>
                        </tr>
                        <tr class="bg-light sub-header">
                            <th>الدرجة(10)</th>
                            <th class="d-none d-print-table-cell d-md-table-cell">مادة النشاط</th>
                            <th>الدرجة(10)</th>
                            <th class="d-none d-print-table-cell d-md-table-cell">مادة النشاط</th>
                        </tr>
                    </thead>

                    <!-- ب. الجسم -->
                    <tbody>
                        <tr v-for="(student, sIndex) in school.students" :key="sIndex">
                        <td class="fw-bold fs-5">{{ student.Seating_No }}</td>
                        
                        <td class="text-end pe-2 fs-6">
                            <div class="d-flex flex-column flex-md-row justify-content-between align-items-md-center">
                            <span class="fw-bold text-nowrap">{{ student.Arabic_Name | truncate(25) }}</span>
                            <div class="mt-1 mt-md-0">
                                <span v-if="student.Damg_Status === 'دمج'" class="badge bg-warning text-dark border border-dark small-badge mx-1">دمج</span>
                                <span v-if="student.Stud_Type_Id == 2" class="badge bg-secondary small-badge mx-1">منازل</span>
                            </div>
                            </div>
                        </td>

                        <!-- خانات الدرجات -->
                        <td class="write-area"></td> 
                        <td class="text-muted small d-none d-print-table-cell d-md-table-cell"></td>
                        <td class="write-area"></td>
                        <td class="text-muted small d-none d-print-table-cell d-md-table-cell"></td>
                        <td class="write-area"></td>
                        </tr>
                    </tbody>
                    </table>
                </div>

                <!-- ج. التذييل (يظهر مرة واحدة في نهاية المدرسة) -->
                <div class="footer-section mt-4 px-5">
                    <div class="row text-center gy-4">
                        <div class="col-6 text-start">
                             <h5 class="fw-bold">رئيس اللجنة</h5>
                             <p class="mt-4">................................</p>
                        </div>
                        <div class="col-6 text-end">
                             <h5 class="fw-bold">مدير المدرسة</h5>
                             <p class="mt-4">................................</p>
                        </div>
                    </div>
                </div>

            </div>
               
        </div>
      </div>
    </div>

    <!-- رسالة فارغة -->
    <div v-else-if="searched && !loading" class="alert alert-warning text-center mt-4 no-print">
        لا توجد بيانات للعرض، تأكد من اختيار الفلاتر والضغط على بحث.
    </div>

  </div>
</template>

<script>
import api from '@/api/axios';
import ControlFilters from '@/components/ControlFilters.vue';

export default {
  components: { ControlFilters },
  name: "SeatingReviewReport",
  data() {
    return {
      loading: false,
      searched: false,
      schoolsData: [], 
      administrations: [],     
      printOptions: {
        admin: '', // تخزين الإدارة المختارة
        term: '', // الترم الافتراضي
      },
    };
  },
  
  computed: {
    // 1. خاصية محسوبة لتغيير اسم الترم تلقائياً
    termName() {
        // const termsMap = {
        //     'term1': 'الأول',
        //     'term2': 'الثاني',
        //     'round2': 'الدور الثاني'
        // };
        // نأخذ القيمة من printOptions التي يتم تحديثها عند البحث
        return this.printOptions.term.name || 'الأول';
    }
  },

  filters:{
    truncate(value, length) {
        if (!value) return '';
        if (value.length <= length) return value;
        return value.substring(0, length) + '...';
    }
  },

  mounted() {
    this.fetchAdmins();
  },

  methods: {
    async fetchAdmins() {
        // يفضل جلبها من الـ API لضمان تطابق الأسماء والأكواد
        try {
             // const res = await api.get('/admin/administrations');
             // this.administrations = res.data;
             
             // بيانات مؤقتة للتجربة
             this.administrations = [
                { id: 1, name: 'العريش' }, 
                { id: 2, name: 'بئر العبد' },
                { id: 3, name: 'الشيخ زويد' },
                { id: 4, name: 'رفح' },
                { id: 5, name: 'الحسنة' },
                { id: 6, name: 'نخل' }
            ];
        } catch (e) { console.error(e); }
    },

    fetchReport(filters) {
      this.loading = true;
      this.searched = true;
    //   console.log(filters);
      
      // تحديث خيارات الطباعة بناء على الفلتر القادم من المكون الابن
      this.printOptions = { ...filters }; 

      this.schoolsData = [];
      
      api.post('/admin/reports/seating-review', filters)
        .then(res => {
            this.schoolsData = res.data;
        })
        .catch((e) => {
            console.error(e);
            // alert("حدث خطأ في جلب البيانات");
        })
        .finally(() => this.loading = false);
    },

    // 2. دالة للحصول على اسم الإدارة
    getAdminName(id) {
        if (!id) return ".....";
        const admin = this.administrations.find(a => a.id == id);
        return admin ? admin.name : '';
    },

    printPage() {
        this.$htmlToPaper("printMe");
    }
  }
};
</script>

<style scoped>
@media print {
    .no-print { display: none !important; }
    #printMe { visibility: visible; }
    
    .school-section {
        page-break-after: always;
        page-break-inside: avoid;
        direction: rtl;
    }
    
    thead { display: table-header-group; }
    tr { page-break-inside: avoid; }

    /* تنسيق الجدول للطباعة */
    .table-bordered th, 
    .table-bordered td {
        border: 2px solid #000 !important;
        font-size: 14pt; /* خط مناسب للقراءة */
        padding: 8px;
        color: #000 !important;
    }
    
    .bg-light { 
        background-color: #f0f0f0 !important; 
        -webkit-print-color-adjust: exact; 
        print-color-adjust: exact;
    }
    
    .badge {
        border: 1px solid #000 !important;
        color: #000 !important;
    }
}
</style>